import { HttpApiGroup } from "@effect/platform";
import { endpoint } from "../auth/endpoint";
import { HealthRequest, HealthResponse } from "../models/health";

export const HealthGroup = HttpApiGroup.make("health")
  .add(endpoint.public.get("getHealth", "/health").addSuccess(HealthResponse))
  .add(
    endpoint.public
      .post("postHealth", "/health")
      .addSuccess(HealthResponse)
      .setPayload(HealthRequest),
  );
